/* STRIDE theme — interactions: cart drawer, mobile nav, FAQ, gallery, qty */
(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) =>
    window.Shopify && Shopify.formatMoney
      ? Shopify.formatMoney(cents, window.STRIDE_MONEY_FORMAT)
      : "$" + (cents / 100).toFixed(2);

  /* ---------- overlay + drawers ---------- */
  const overlay = $("#overlay");
  const cartDrawer = $("#cart-drawer");
  const mobileNav = $("#mobile-nav");

  function closeAll() {
    [cartDrawer, mobileNav].forEach((el) => el && el.classList.remove("is-open"));
    overlay && overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  function open(el) {
    if (!el) return;
    el.classList.add("is-open");
    overlay && overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  overlay && overlay.addEventListener("click", closeAll);
  document.addEventListener("keydown", (e) => e.key === "Escape" && closeAll());
  $$("[data-close-drawer]").forEach((b) => b.addEventListener("click", closeAll));
  $$("[data-open-cart]").forEach((b) =>
    b.addEventListener("click", (e) => {
      e.preventDefault();
      renderCart();
      open(cartDrawer);
    })
  );
  $$("[data-open-nav]").forEach((b) =>
    b.addEventListener("click", (e) => {
      e.preventDefault();
      open(mobileNav);
    })
  );

  /* ---------- cart (AJAX) ---------- */
  async function getCart() {
    const r = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return r.json();
  }
  function setBubble(count) {
    $$(".cart-count").forEach((el) => {
      el.textContent = count;
      el.style.display = count > 0 ? "grid" : "none";
    });
  }
  async function renderCart() {
    const body = $("#cart-drawer-body");
    const foot = $("#cart-drawer-foot");
    if (!body) return;
    body.innerHTML = '<p class="cart-empty">Loading…</p>';
    const cart = await getCart();
    setBubble(cart.item_count);
    if (!cart.item_count) {
      body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      foot && (foot.hidden = true);
      return;
    }
    foot && (foot.hidden = false);
    body.innerHTML = cart.items
      .map(
        (it) => `
      <div class="cart-line" data-key="${it.key}">
        <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") : ""}" alt="${it.product_title}">
        <div style="flex:1">
          <div style="font-weight:700">${it.product_title}</div>
          <div style="font-size:.85rem;color:rgba(18,18,18,.6)">Qty ${it.quantity}</div>
          <button data-remove="${it.key}" style="background:none;border:0;color:#c0392b;cursor:pointer;padding:4px 0;font-size:.82rem">Remove</button>
        </div>
        <div style="font-weight:800">${money(it.final_line_price)}</div>
      </div>`
      )
      .join("");
    const sub = $("#cart-subtotal");
    sub && (sub.textContent = money(cart.total_price));
    $$("[data-remove]", body).forEach((btn) =>
      btn.addEventListener("click", async () => {
        await changeItem(btn.getAttribute("data-remove"), 0);
        renderCart();
      })
    );
  }
  async function changeItem(key, qty) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
  }
  async function addItem(id, qty, plan) {
    const r = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [Object.assign({ id: Number(id), quantity: qty }, plan ? { selling_plan: Number(plan) } : {})] }),
    });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || "Could not add to cart.");
    return j;
  }

  /* ---------- product form ---------- */
  $$("[data-product-form]").forEach((form) => {
    const qtyInput = $("[data-qty-input]", form);
    $$("[data-qty]", form).forEach((b) =>
      b.addEventListener("click", () => {
        let v = parseInt(qtyInput.value || "1", 10);
        v += b.dataset.qty === "up" ? 1 : -1;
        qtyInput.value = Math.max(1, v);
      })
    );
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const id = $("[name='id']", form).value;
      const qty = parseInt(qtyInput ? qtyInput.value : "1", 10);
      const btn = $("[data-add-btn]", form);
      const label = btn ? btn.textContent : "";
      btn && (btn.textContent = "Adding…", (btn.disabled = true));
      try {
        const planEl = $("[name='selling_plan']", form); await addItem(id, qty, planEl ? planEl.value : "");
        if (form.hasAttribute("data-direct-checkout")) { window.location.href = "/checkout"; return; }
        await renderCart();
        open(cartDrawer);
      } catch (err) {
        const old = form.querySelector(".sx-err"); old && old.remove(); btn && btn.insertAdjacentHTML("afterend", '<p class="sx-err" style="color:#b42318;font-size:.9rem;margin:8px 0 0;text-align:center">' + err.message + "</p>");
      } finally {
        btn && ((btn.textContent = label), (btn.disabled = false));
      }
    });
  });

  /* ---------- product gallery ---------- */
  $$("[data-gallery]").forEach((g) => {
    const main = $("[data-gallery-main]", g);
    $$("[data-thumb]", g).forEach((t) =>
      t.addEventListener("click", () => {
        if (main) main.src = t.dataset.full || t.src;
        $$("[data-thumb]", g).forEach((x) => x.classList.remove("is-active"));
        t.classList.add("is-active");
      })
    );
  });

  /* ---------- FAQ accordion ---------- */
  $$(".faq-item").forEach((item) => {
    const q = $(".faq-q", item);
    q &&
      q.addEventListener("click", () => {
        const open = item.classList.contains("is-open");
        item.classList.toggle("is-open", !open);
      });
  });

  /* ---------- init ---------- */
  getCart().then((c) => setBubble(c.item_count)).catch(() => {});
})();
